/** Ordem lógica do funil de venda (filtros e relatórios). */
export const PASSAGEM_STATUS_VENDA_ORDER = [
  "em_andamento",
  "aguardando_pagamento",
  "paga",
  "emitida",
  "cancelada",
  "estornada",
  "chargeback",
  "erro_emissao",
];

/** Status exibidos no filtro da lista de vendas (não inclui funil do pipeline). */
export const PASSAGEM_LIST_STATUS_FILTER_KEYS = [
  "emitida",
  "paga",
  "erro_emissao",
  "cancelada",
  "chargeback",
];

export function passagemListStatusFilterKeys() {
  return [...PASSAGEM_LIST_STATUS_FILTER_KEYS];
}

/** Chip color for sales list statuses that need attention. */
export function passagemStatusChipColor(status) {
  const s = String(status || "").trim().toLowerCase();
  if (s === "emitida") return "success";
  if (s === "paga" || s === "erro_emissao") return "error";
  if (s === "chargeback" || s === "estornada") return "error";
  if (s === "cancelada") return "default";
  if (s === "aguardando_pagamento") return "warning";
  return "default";
}

export function sortPassagemStatusKeys(keys = []) {
  const rank = new Map(PASSAGEM_STATUS_VENDA_ORDER.map((k, i) => [k, i]));
  return [...keys].sort((a, b) => (rank.get(a) ?? 99) - (rank.get(b) ?? 99));
}

/** Rótulo amigável para status_venda (passagens_vendas). */
export function passagemStatusLabel(t, key) {
  if (!key) return "—";
  const k = String(key).trim();
  return t(`passagensPage.status_${k}`, {
    defaultValue: t(`platformPage.passengerStatus_${k}`, {
      defaultValue: k.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
    }),
  });
}
